import React, { useState, useEffect } from 'react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import EditPopup from '../../components/Popup/EditPopup/EditPopup'; 
import AddPopup from '../../components/Popup/AddPopup/AddPopup';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import AddButton from '../../components/common/AddButton/AddButton';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import '../../components/PopupCommon/Popupcommon.css';
import '../../components/PopupCommon/ExchangeHistory.css';
import './Currencies.css';
import ExchangeRatePopup from '../../components/Popup/ExchangeRatePopup/ExchangeRatePopup';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import { baseurl } from '../../api';
import { isTextOnly,isNumberOnly,isSymbolOnly,isRequired, minDigit, maxDigit, isFloat } from '../../validation';
import { useCheckboxClick } from '../../checkboxclick';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import useRefreshStore from '../../store/useRefreshStore';
const pageKey = "currency"

const Currencies = () => {
    const { setFilters, getFilters } = useFilterStore();
    const savedFilters = getFilters(pageKey);
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);   
    const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
    const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
    const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [isExchangeRatePopupOpen, setIsExchangeRatePopupOpen] = useState(false);
    const [popupError, setPopupError] = useState('');
    const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
    const [exportState, setExportState] = useState({
        isExporting: false,
        error: null
    });
    const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
    const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
    const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
    const navigate = useNavigate();
    const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
    const filterOptions = ['Default', 'Archived', 'Unarchived'];
    const { refreshKeys } = useRefreshStore();
    const refreshKey = refreshKeys["Currencies"] || 0;

    const fetchCurrencies = async (id = null) => {
        try {
          if (id) {
            const response = await authenticatedAxios.get(`${baseurl}currency/?id=${id}`);
            if (response && response.data) {
              setSelectedItem(response.data.data);
              setIsEditPopupOpen(true);
            } else {
              console.error("No data found for the selected currency.");
            }
          } else {
            const params = {
              search: searchParams.term,
              filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
              sort: mapSortOptionToQuery(selectedSortOption),
            };
      
            const response = await authenticatedAxios.get(`${baseurl}currency/`, { params });
            setItems(response.data?.data || []);
          }
        } catch (error) {
          if (error?.response?.data?.error_code === 1001) {
            navigate("/permission-denied");
          } else {
            console.error('Error fetching currencies:', error);
          }
          setItems([]);
        } finally {
          setIsLoading(false);
        }
    };
        
    useEffect(() => {
        
        fetchCurrencies();
        setFilters(pageKey, {
            searchParams,
            selectedFilterOption,
            selectedSortOption,
        });
    }, [searchParams, selectedFilterOption, selectedSortOption]); 

    useEffect(() => {
        fetchCurrencies();
    }, [refreshKey]);
    

    const handleSearchSelect = (term) => {
        setSearchParams({term });
    };

    const mapSortOptionToQuery = (option) => {
        switch (option) {
            case 'A-Z':
                return 'a_to_z';
            case 'Z-A':
                return 'z_to_a';
            case 'Newest':
                return 'newest';
            case 'Oldest':
                return 'oldest';
            default:
                return 'newest';
        }
    };


    // const handleAddCurrency = async (formValues) => {
    //     try {
    //         const response = await authenticatedAxios.post(`${baseurl}currency/`, formValues, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data'
    //             }
    //         });

    //         if (response.status >= 200 && response.status < 300) {
    //             fetchCurrencies();
    //             closePopups();
    //         } else {
    //             console.error('Failed to add currency');
    //         }
    //     } catch (error) {
    //         console.error('Error adding currency:', error);
    //     }
    // };

    // const handleEditCurrency = async (formValues) => {
    //     try {    
    //         const response = await authenticatedAxios.put(`${baseurl}currency/?id=${selectedItem.id}`, formValues, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data'
    //             }
    //         });
    
    //         if (response.status >= 200 && response.status < 300) {
    //             const updatedCurrency = response.data?.data;
                
    //             if (updatedCurrency) {
    //                 setItems(prevCurrencies => 
    //                     prevCurrencies.map(curr => 
    //                         curr.id === selectedItem.id ? updatedCurrency : curr
    //                     )
    //                 );
    //                 fetchCurrencies();
    //                 closePopups();
    //             } else {
    //                 console.error('Invalid response data structure');
    //             }
    //         }
    //     } catch (error) {
    //         console.error('Error editing currency:', error);
    //     }
    // };

    const handleAddCurrency = async (formValues) => {
        try {
            const response = await authenticatedAxios.post(`${baseurl}currency/`, formValues, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    
            if (response.data.response_code === 1) {
                fetchCurrencies();
                closePopups();
            } else {
                setPopupError(response.data.message || 'Failed to add currency');
            }
        } catch (error) {
            setPopupError('Error adding currency. Please try again.');
        }
    };
    
    const handleEditCurrency = async (formValues) => {
        try {    
            const response = await authenticatedAxios.put(`${baseurl}currency/?id=${selectedItem.id}`, formValues, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    
            if (response.data.response_code === 1) {
                const updatedCurrency = response.data?.data;
    
                if (updatedCurrency) {
                    setItems(prevCurrencies => 
                        prevCurrencies.map(curr => 
                            curr.id === selectedItem.id ? updatedCurrency : curr
                        )
                    );
                    fetchCurrencies();
                    closePopups();
                } else {
                    setPopupError('Invalid response data.');
                }
            } else {
                setPopupError(response.data.message || 'Failed to edit currency');
            }
        } catch (error) {
            setPopupError('Error editing currency. Please try again.');
        }
    };
    

    const handleDelete = async () => {
        try {
          const response = await authenticatedAxios.delete(
            `${baseurl}currency/?id=${selectedItem.id}`
          );
      
          if (response.status >= 200 && response.status < 300) {
            setIsDeletePopupOpen(false); 
            fetchCurrencies(); 
            return;
          }
          throw new Error(`Unexpected status code: ${response.status}`);
        } catch (error) {
          // console.error('Error deleting plan:', error);
        }
    };

    const handleArchiveSelectedItems = async () => {
        try {
          const response = await authenticatedAxios.post(`${baseurl}currency/archive/`, {
            id_list: selectedItems,
          });
      
          if (response.status >= 200 && response.status < 300) {
            fetchCurrencies();
            resetCheckboxState();
            setIsArchivePopupOpen(false);
          }
        } catch (error) {
   
        }
    };
      
  

    const handleArchive = async () => {
        try {
            const response = await authenticatedAxios.get(
                `${baseurl}currency/archive/?id=${selectedItem.id}`
            );
    
            if (response.status >= 200 && response.status < 300) {
                await fetchCurrencies(); 
                closePopups(); 
            } 

        } catch (error) {
            
        }
    };

    const handleExchangeRateClick = () => {
        setIsExchangeRatePopupOpen((prev) => !prev);
    };

    
    const handleEditClick = (currency) => {
        fetchCurrencies(currency.id)
    };

    const handleArchiveClick = async (item) => {
        setSelectedItem(item);
        setIsArchivePopupOpen(true);
    };

    const handleDeleteClick = async (item) => {
        setSelectedItem(item);
        setIsDeletePopupOpen(true);
    };


    const handleNewClick = () => {
        setSelectedItem(null);
        setIsNewPopupOpen(true);
    };


    const handleSortOptionSelect = (option) => {
        setSelectedSortOption(option); 
    };

    const handleFilterSelect = (option) => {
        setSelectedFilterOption(option);
    };

    const closePopups = () => {
        setIsEditPopupOpen(false);
        setIsArchivePopupOpen(false);
        setIsNewPopupOpen(false);
        setIsExchangeRatePopupOpen(false);
        setSelectedItem(null);
        setPopupError('');
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    const editPopupFields = [
        { label: 'Currency Name', name: 'name', type: 'large-input', validators: [isRequired, isTextOnly], defaultValue: selectedItem?.name || '' },
        { label: 'Currency Code', name: 'currency_code', type: 'small-input',validators: [isRequired, maxDigit(3),isTextOnly], defaultValue: selectedItem?.currency_code || '' },
        { label: 'Symbol', name: 'symbol', type: 'small-input',validators: [isRequired, isSymbolOnly], defaultValue: selectedItem?.symbol || '' },
        { label: 'Decimal Places', name: 'decimal_places', type: 'small-input',validators: [isRequired, isNumberOnly,minDigit(1),maxDigit(5)], defaultValue: selectedItem?.decimal_places || '' },
        { label: 'Base Exchange Rate in USD', name: 'exchange_rate', type: 'small-input',validators: [ minDigit(1),maxDigit(5)], defaultValue: selectedItem?.exchange_rate || '' }
    ];

    const addPopupFields = [
        { label: 'Currency Name', name: 'name', type: 'large-input', validators: [isRequired, isTextOnly] },
        { label: 'Currency Code', name: 'currency_code', type: 'small-input', validators: [isRequired, maxDigit(3), isTextOnly] },
        { label: 'Symbol', name: 'symbol', type: 'small-input', validators: [isRequired, isSymbolOnly] },
        { label: 'Decimal Places', name: 'decimal_places', type: 'small-input', validators: [isRequired, isNumberOnly,minDigit(1),maxDigit(5)] },
        { label: 'Base Exchange Rate in USD', name: 'exchange_rate', type: 'small-input', validators: [ isFloat,minDigit(1),maxDigit(5)] },
    ];

    const deletePopupFields = [
        { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
    ];

    const handleExportStart = () => {
        setExportState({ isExporting: true, error: null });
      };
    
      const handleExportComplete = () => {
        setExportState({ isExporting: false, error: null });
        resetCheckboxState();
      };
    
      const handleExportError = (error) => {
        setExportState({ isExporting: false, error });
      };    
    return (
        <div className="whole-container">
            <div className="top-heading">
                <PageHeader pageName=" Localization /" nestedpageName="Currencies"  linkTo="" /> 
                <div className="export-container">
                    <ArchiveSelectedItem
                    selectedItems={selectedItems}
                    items={items}
                    onArchiveSelected={handleArchiveSelectedItems}
                    />
                    <ExportLabel
                        exportUrl={`${baseurl}currency/export/`}
                        selectedIds={selectedItems}
                        onExportStart={handleExportStart}
                        onExportComplete={handleExportComplete}
                        onExportError={handleExportError}
                    />
                </div>
            </div>
            <div className="pagename-container">
                <div className="page-name">
                    <h1 className="common-text fts-22 ftw-6 blue">Currencies</h1>
                </div>
                <div className="pagename-right-container">
                    <AddButton onClick={handleNewClick} />
                    <SimpleSearchBox placeholder="Search Currencies" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term}/>
                    <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption}/>
                    <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption}/>
                </div>
            </div>
            <div className="table-container">
                <table className="common-table">
                    <thead className="common-table-head">
                        <tr className="common-table-thead-tr">
                            <th>
                                <input
                                    className="table-selectbox table-parent-selectbox"
                                    type="checkbox"
                                    checked={isParentSelected}
                                    onChange={handleParentCheckboxChange}
                                />CURRENCY NAME
                            </th>
                            <th>CURRENCY CODE</th>
                            <th>SYMBOL</th>
                            <th>DECIMAL PLACES</th>
                            <th>Base exchange rate (USD)
                            <svg className='basic-ex-rate-icon' width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleExchangeRateClick}>
                                <path d="M10.2857 0C8.23976 0 6.2776 0.790176 4.83089 2.1967C3.38418 3.60322 2.57143 5.51087 2.57143 7.5H0L3.33429 10.7417L3.39429 10.8583L6.85714 7.5H4.28571C4.28571 4.275 6.96857 1.66667 10.2857 1.66667C13.6029 1.66667 16.2857 4.275 16.2857 7.5C16.2857 10.725 13.6029 13.3333 10.2857 13.3333C8.63143 13.3333 7.13143 12.675 6.05143 11.6167L4.83429 12.8C5.54853 13.4985 6.398 14.0525 7.33366 14.4301C8.26932 14.8077 9.27265 15.0014 10.2857 15C12.3317 15 14.2938 14.2098 15.7405 12.8033C17.1872 11.3968 18 9.48912 18 7.5C18 5.51087 17.1872 3.60322 15.7405 2.1967C14.2938 0.790176 12.3317 2.96402e-08 10.2857 0ZM9.42857 4.16666V8.33333L13.0714 10.4333L13.7314 9.36666L10.7143 7.625V4.16666H9.42857Z" fill="#094C80"/>
                            </svg>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody className="common-table-tbody">
                    {items.length > 0 ? (
                        items.map((currency) => (
                        <tr key={currency.id} className={currency.is_archived ? 'archived-item' : ''}>
                            <td className='d-flex ai-center'>
                            <input
                                className="table-selectbox table-child-selectbox"
                                type="checkbox"
                                checked={selectedItems.includes(currency.id)}
                                onChange={() => handleChildCheckboxChange(currency.id)}
                            />
                            {currency.name}
                            </td>
                            <td>{currency.currency_code}</td>
                            <td>{currency.symbol}</td>
                            <td>{currency.decimal_places}</td>
                            <td>{currency.exchange_rate}</td>
                            <td className="actions common-action">
                            <EditIcon onClick={() => handleEditClick(currency)} />
                            <ArchiveIcon onClick={() => handleArchiveClick(currency)} isArchived={currency.is_archived} />
                            <DeleteIcon onClick={() => handleDeleteClick(currency)} />
                            </td>
                        </tr>
                        ))
                    ) : (
                        <tr>
                        <td colSpan="6">
                            No Currency available
                        </td>
                        </tr>
                    )}
                    </tbody>

                </table>
            </div>

            <EditPopup
                isOpen={isEditPopupOpen}
                title="Edit Currency"
                fields={editPopupFields}
                onSave={handleEditCurrency}
                onClose={closePopups}
                popupErrorMessage={popupError}
            />

            <AddPopup
                isOpen={isNewPopupOpen}
                title=" New Currency"
                buttonName='Add Currency'
                fields={addPopupFields}
                onSave={handleAddCurrency}
                onClose={closePopups}
                popupErrorMessage={popupError}
                
            />

            <ArchivePopup
                isOpen={isArchivePopupOpen}
                isArchived={selectedItem?.is_archived}
                archivename={selectedItem?.name }
                onSave={handleArchive}
                onClose={() => setIsArchivePopupOpen(false)}
            />

            <ExchangeRatePopup
                isOpen={isExchangeRatePopupOpen}
                onClose={closePopups}
            />
            <DeletePopup
                isOpen={isDeletePopupOpen}
                title="Delete Currency"
                fields={deletePopupFields}
                onSave={handleDelete}
                onClose={closePopups}
            /> 
        </div>
    );
};

export default Currencies;
